module.exports = __webpack_public_path__ + "img/img_kiwoom_search2.b8a213ad.png";